import {useQueries} from '@tanstack/react-query'
import {getCategoryList} from '@/services/CategoryService/category'

export const useCategoryList = () => {
  const results = useQueries({
    queries: [
      {
        queryKey: ['CATEGORY_LIST'],
        queryFn: getCategoryList,
      },
    ],
  })

  return {
    categoryListData: results?.[0]?.data?.data || [],
  }
}
